// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrLockboxDtoDetails } from './IOcrLockboxDtoDetails';
import {
    IOcrLockboxDtoDetailsFromJSON,
    IOcrLockboxDtoDetailsFromJSONTyped,
    IOcrLockboxDtoDetailsToJSON,
    IOcrLockboxDtoDetailsToJSONTyped,
} from './IOcrLockboxDtoDetails';
import type { IAddress } from './IAddress';
import {
    IAddressFromJSON,
    IAddressFromJSONTyped,
    IAddressToJSON,
    IAddressToJSONTyped,
} from './IAddress';

/**
 * 
 * @export
 * @interface IOcrLockboxDto
 */
export interface IOcrLockboxDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxDto
     */
    account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxDto
     */
    birth_date?: string;
    /**
     * 
     * @type {number}
     * @memberof IOcrLockboxDto
     */
    amount?: number;
    /**
     * 
     * @type {IAddress}
     * @memberof IOcrLockboxDto
     */
    address?: IAddress;
    /**
     * 
     * @type {Array<number>}
     * @memberof IOcrLockboxDto
     */
    claim_ids?: Array<number>;
    /**
     * 
     * @type {IOcrLockboxDtoDetails}
     * @memberof IOcrLockboxDto
     */
    details?: IOcrLockboxDtoDetails;
}

/**
 * Check if a given object implements the IOcrLockboxDto interface.
 */
export function instanceOfIOcrLockboxDto(value: object): value is IOcrLockboxDto {
    return true;
}

export function IOcrLockboxDtoFromJSON(json: any): IOcrLockboxDto {
    return IOcrLockboxDtoFromJSONTyped(json, false);
}

export function IOcrLockboxDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrLockboxDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_number': json['accountNumber'] == null ? undefined : json['accountNumber'],
        'first_name': json['firstName'] == null ? undefined : json['firstName'],
        'last_name': json['lastName'] == null ? undefined : json['lastName'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'birth_date': json['birthDate'] == null ? undefined : json['birthDate'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'address': json['address'] == null ? undefined : IAddressFromJSON(json['address']),
        'claim_ids': json['claimIds'] == null ? undefined : json['claimIds'],
        'details': json['details'] == null ? undefined : IOcrLockboxDtoDetailsFromJSON(json['details']),
    };
}

export function IOcrLockboxDtoToJSON(json: any): IOcrLockboxDto {
    return IOcrLockboxDtoToJSONTyped(json, false);
}

export function IOcrLockboxDtoToJSONTyped(value?: IOcrLockboxDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountNumber': value['account_number'],
        'firstName': value['first_name'],
        'lastName': value['last_name'],
        'ssn': value['ssn'],
        'birthDate': value['birth_date'],
        'amount': value['amount'],
        'address': IAddressToJSON(value['address']),
        'claimIds': value['claim_ids'],
        'details': IOcrLockboxDtoDetailsToJSON(value['details']),
    };
}

